/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Locality_SearchInputs */

const cs_requirements_locality_search = /** @type {(inputs: Requirements_Locality_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat město nebo okres`)
};

const en_requirements_locality_search = /** @type {(inputs: Requirements_Locality_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search city or district`)
};

/**
* | output |
* | --- |
* | "Search city or district" |
*
* @param {Requirements_Locality_SearchInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_locality_search = /** @type {((inputs?: Requirements_Locality_SearchInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Locality_SearchInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_locality_search(inputs)
	return cs_requirements_locality_search(inputs)
});